import {ContactBase, OrganizationResponse, ProjectResponse, ProjectsService} from '@backend';
import {CommonsSearchProject, CommonsSearchProjectFlagsOnly} from '@models/commons-types';
import {TileInfo} from '@models/tile-info';
import {ProjectFlags} from '@shared/constants/constants';

// Project Base UI model. This is the common ancestor for all project views.
export interface ProjectBaseModel {
  id: string;
  name: string;
  description: string;
  keywords: string[];
  storage_organization: OrganizationResponse;
  partners: string[];
  funders: string[];
  web_page_urls: string[] | null;
  contacts?: ContactBase[] | ContactBase;
  flags: CommonsSearchProjectFlagsOnly;
}

// Mapper that takes a public search project (with flags) and returns a ProjectBaseModel
export function mapSearchProjectToBaseModel(project: CommonsSearchProject): ProjectBaseModel {
  const flags: CommonsSearchProjectFlagsOnly = Object.fromEntries(
    Object.values(ProjectFlags).map(flag => [flag, Boolean(project[flag])]),
  ) as CommonsSearchProjectFlagsOnly;

  return {
    id: project.id!,
    name: project.name,
    description: project.description,
    keywords: project.keywords,
    storage_organization: project.storage_organization,
    partners: project.partners,
    funders: project.funders,
    web_page_urls: project.web_page_urls,
    contacts: project.contacts,
    flags,
  };
}

// Resolver return type for any project page
export interface ProjectPageData {
  project: ProjectBaseModel;
  datasetTiles: TileInfo[];
  resourceTiles: TileInfo[];
}

// Resolver return type for private project pages
export interface PrivateProjectPageData extends ProjectPageData {
  privateProject: ProjectResponse;
  projectsService: ProjectsService;
}
